/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTemplateDto } from '../../models/ticket-template-dto';
import { TicketTemplateEditAmountDto } from '../../models/ticket-template-edit-amount-dto';

export interface TicketTemplateControllerEditAmount$Params {
  id: string;
      body: TicketTemplateEditAmountDto
}

export function ticketTemplateControllerEditAmount(http: HttpClient, rootUrl: string, params: TicketTemplateControllerEditAmount$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, ticketTemplateControllerEditAmount.PATH, 'patch');
  if (params) {
    rb.query('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTemplateDto>;
    })
  );
}

ticketTemplateControllerEditAmount.PATH = '/api/ticket/{centerId}/template/amount';
